<template>
  <div>
    <q-btn-dropdown
      v-if="!hideAddRemoveButtons"
      :label="label || $t('settings.fundingSources.fields.addTreatmentService')"
      icon="add"
      outline
      data-e2e="dropdown-add-valid-service"
      :disable="!treatmentServiceOptions.length || disable"
      color="primary"
      class="full-width"
    >
      <q-list
        v-close-popup
      >
        <q-item
          v-for="service in treatmentServiceOptions"
          :key="service.id"
          :data-e2e="`dropdown-item-valid-service-${(service.serviceName || '').replace(/ /g, '-')}`"
          clickable
          @click="onAddTreatmentService(service.id)"
        >
          <q-item-section>{{ formatServiceName(service) }}</q-item-section>
        </q-item>
      </q-list>
    </q-btn-dropdown>
    <div
      v-if="!hideItems"
      class="col-12"
    >
      <q-list>
        <q-item
          v-for="service in validTreatmentServices"
          :key="service.id"
          :data-e2e="`list-item-valid-service-${(service.serviceName || '').replace(/ /g, '-')}`"
          clickable
        >
          <q-item-section>
            <span class="text-bold ellipsis full-width">
              {{ formatServiceName(service) }}
            </span>
          </q-item-section>
          <q-item-section
            v-if="!hideAddRemoveButtons"
            side
          >
            <q-btn
              flat
              dense
              round
              icon="close"
              :data-e2e="`button-remove-valid-service-${(service.serviceName || '').replace(/ /g, '-')}`"
              @click="onRemoveTreatmentService(service.id)"
            />
          </q-item-section>
        </q-item>
      </q-list>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TreatmentServicesSelector',

  props: {

    modelValue: {
      type: Array,
      required: true,
    },

    availableTreatmentServices: {
      type: Array,
      required: true,
    },

    disable: {
      type: Boolean,
      default: false,
    },

    hideAddRemoveButtons: {
      type: Boolean,
      default: false,
    },

    hideItems: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '',
    },

  },

  emits: ['update:modelValue'],

  data() {
    return {
    };
  },

  computed: {

    validTreatmentServices() {
      const validTreatmentServices = (this.modelValue || [])
        .map((ts) => (ts.id));
      return this.availableTreatmentServices
        .filter((ts) => (validTreatmentServices.includes(ts.id)))
        .sort(this.sortTreatmentServices);
    },

    treatmentServiceOptions() {
      const validTreatmentServiceIds = (this.modelValue || [])
        .map((ts) => (ts.id));
      return this.availableTreatmentServices
        .filter((ts) => (!validTreatmentServiceIds.includes(ts.id)))
        .sort(this.sortTreatmentServices);
    }, // treatmentServiceOptions()

  },

  methods: {

    onAddTreatmentService(treatmentServiceId) {
      this.$emit(
        'update:modelValue',
        (this.modelValue || [])
          .filter((ts) => (ts.id !== treatmentServiceId)) // Remove existing if any
          .concat([{
            id: treatmentServiceId,
          // Billing rules, etc.
          }]),
      );
      // Add new treatment service by its id
    }, // onAddTreatmentService()

    onRemoveTreatmentService(treatmentServiceId) {
      this.$emit(
        'update:modelValue',
        (this.modelValue || [])
          .filter((ts) => (ts.id !== treatmentServiceId)),
      );
    }, // onRemoveTreatmentService()

    formatServiceName(service) {
      return [service.serviceCode, service.serviceName]
        .filter((part) => !!part)
        .join(' - ');
    }, // formatServiceName()

    sortTreatmentServices(a, b) {
      const aStr = this.formatServiceName(a);
      const bStr = this.formatServiceName(b);
      return aStr.localeCompare(bStr);
    }, // sortTreatmentServices()

  },

};
</script>
